module.exports = __webpack_public_path__ + "img/pro-body-photo2.c5dfef3c.png";